import { createSlice } from "@reduxjs/toolkit";
import { SendReadReceipt } from "../../signalRService/signalRService";
import indexedDB, {
  applyHideStatusToIndexedDB,
  deleteMessage_From_IndexedDB_Parmanent,
  updateMessageSeen_IndexedDB,
  updateUnhidedByChatId_IndexedDB,
} from "../../../../utils/IndexedDBUtils";
const user_id = localStorage.getItem("user_id");

const initialState = {
  messages: [],
  events: [],
  chat_Id: null,
  user_id: null,
  all_chats: [],
  hiddenChats: [],
  typingUsers: "",
  typingFlag: false,
  typingChatId: "",
  otherUserId: null,
  userOnline: false,
  isFav: false,
  isFavChat: false,
  isFavGroupChat: null,
  action: "",
  renderFolder: false,
  emailId: null,
  foldersId: null,
  foldersName: null,
  dispatchFolderId: null,
  newCreatedfolderName: "",
  draftEmails: null,
  pendingDraftEmails: null,
  sideEmailData: [],
  favSideEmailData: [],
  folderSideEmailData: [],
  chatLoginId: null,
  defaultEmailShow: false,
  user_Name: "",
  reaction: [],
  renderReaction: false,
  chatSelectedFromContactList: {},
  contactList: [],
  mainContactList: [],
  clipboardImageURL: [],
  selectedContactName: null,
  selectedContactProfileImage: null,
  allContacts: [],
  otherContactList: [],
  renderContactPanel: false,
  convoType: "",
  searchGroupName: "",
  contactId: null,
  userId: "",
  pagination: { page: 1, pageSize: 50 },
  clearChatRender: false,
  multiSelectChat: false,
  selectedMessages: [],
  senderId: [],
  draftAudioBlob: null,
  draftAudioUrl: null,
  draftInput: "",
  draftFiles: [],
  lastSeenRealTime: new Date(),
  lastSeenRealTimeArr: [],
  draftMessage: [],
  draftChatId: null,
  muteChatRealTime: [],
  hitDraftApi: false,
  fileUploadProgress: 0,
  isFileUploading: false,
  callLogsUserID: null,
  userData: [],
  updatedGroupName: "",
  chatGroupParticipants: [],
  chatGroupName: "",
  callHistory: [],
  callLogsEventDetails: [],
  sync: false,
  externalContactNumber: null,
  isExternalValidation: false,
  chatParticipantCount: 0,
  isExternalFilter: false,
  autoForwardChat: null,
  externalName: null,
  imageDeleted: false,
  chatParticipantsCount: null,
  deleteContact: null,
  externalNo: "",
  openExternalModal: false,
  isUserContactExists: null,
  newExternalConversation: [],
  deletedAttachmentFile: [],
};
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setAutoForwardChat: (state, action) => {
      state.autoForwardChat = action.payload;
    },
    setSingleAutoForwardChat: (state, action) => {
      if (state.isExternalFilter) {
        state.all_chats?.push(action.payload[0]);
      } else {
        state.userData = state.userData.map((user) => {
          return {
            ...user,
            isAutoforward: true,
          };
        });
      }
    },
    setIsExternalAllow: (state, action) => {
      state.userData = state.userData.map((user) => {
        return {
          ...user,
          isExternalChatAllowed: action.payload,
        };
      });
    },
    setIsExternalFilter: (state, action) => {
      state.isExternalFilter = action.payload;
    },
    setNewExternalConversation: (state, action) => {
      const conversation = action.payload;
      state.allContacts = state.allContacts?.map((contact, index) => {
        if (contact?.userContactId == conversation?.userContactId) {
          return {
            ...contact,
            conversation: {
              conversationId: conversation?.conversationId,
            },
          };
        }
        return contact;
      });
    },
    setChatParticipantsCount: (state, action) => {
      state.chatParticipantsCount = action.payload;
    },
    setAddRemoveParticipantsCount: (state, action) => {
      if (
        state.chat_Id === action?.payload?.chatId &&
        action?.payload?.add === true
      ) {
        state.chatParticipantsCount = state.chatParticipantsCount + 1;
      } else {
        state.chatParticipantsCount = state.chatParticipantsCount - 1;
      }
    },
    setExternalName: (state, action) => {
      state.externalName = action.payload;
    },
    setExternalNo: (state, action) => {
      state.externalNo = action.payload;
    },
    // region external new chat
    setSingleNewChat: (state, action) => {
      const singleNewChat = action.payload;
      const payload = {
        chatId: singleNewChat?.conversationId,
        isAutoforward: false,
        conversationType: "Single",
        name: singleNewChat?.senderNo,
        externalNumber: singleNewChat?.senderNo,
        externalName: null,
        unreadCount: 1,
        createdDate: singleNewChat?.createdDate,
        isExternal: true,
        lastMessage: {
          messageId: singleNewChat?.messageId,
          messageContent: singleNewChat?.messageContent,
          createdDate: singleNewChat?.createdDate,
          isDraft: null,
          senderName: "",
          reactions: null,
        },
        lastCall: null,
      };
      state.all_chats.unshift(payload);
    },
    setOpenExternalModal: (state, action) => {
      state.openExternalModal = action.payload;
    },
    setExternalContactId: (state, action) => {
      state.externalContactId = action.payload;
    },
    setEmailId: (state, action) => {
      state.emailId = action.payload;
    },
    setImageDeleted: (state, action) => {
      state.imageDeleted = action.payload;
    },
    setUser_Id: (state, action) => {
      state.user_id = action.payload;
    },
    setAction: (state, action) => {
      state.action = action.payload;
    },
    setEventsInChat: (state, action) => {
      state.events = action.payload;
    },
    setEventsRealTime: (state, action) => {
      const userid_local = localStorage.getItem("user_id");
      if (action.payload?.conversationId == state.chat_Id) {
        state.events.push(action.payload);
        if (
          action.payload.add === false &&
          action.payload.userid.toString() === userid_local
        ) {
          state.chat_Id = null;
        }
      }
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    setRenderFolder: (state, action) => {
      state.renderFolder = action.payload;
    },
    setFoldersId: (state, action) => {
      state.foldersId = action.payload;
    },
    setDispatchFoldersId: (state, action) => {
      state.dispatchFolderId = action.payload;
    },
    setFoldersName: (state, action) => {
      state.foldersName = action.payload;
    },
    setNewCreatedfolderName: (state, action) => {
      state.newCreatedfolderName = action.payload;
    },
    setDraftEmails: (state, action) => {
      state.draftEmails = action.payload;
    },
    setPendingDraftEmails: (state, action) => {
      state.pendingDraftEmails = action.payload;
    },
    setSideEmailData: (state, action) => {
      state.sideEmailData = action.payload;
    },
    setFavSideEmailData: (state, action) => {
      state.favSideEmailData = action.payload;
    },
    setFolderSideEmailData: (state, action) => {
      state.folderSideEmailData = action.payload;
    },
    setDefaultEmailShow: (state, action) => {
      state.defaultEmailShow = action.payload;
    },
    setUser_Name: (state, action) => {
      state.user_Name = action.payload;
    },
    setRenderReaction: (state, action) => {
      state.renderReaction = action.payload;
    },
    setContactList: (state, action) => {
      state.contactList = action.payload;
    },
    addSingleContact: (state, action) => {
      state.contactList.push(action.payload);
    },
    setMainContactList: (state, action) => {
      state.mainContactList = action.payload;
    },
    addSingleMainContactList: (state, action) => {
      state.mainContactList.push(action.payload);
    },
    setAllContacts: (state, action) => {
      state.allContacts = action.payload;
    },
    addSingleAllContacts: (state, action) => {
      state.allContacts.push(action.payload);
    },
    setDeleteContact: (state, action) => {
      const contactId = action.payload;
      state.allContacts = state.allContacts?.filter(
        (item) => item?.userContactId != contactId
      );
    },
    addSingleParticipant: (state, action) => {
      state.all_chats.push(action.payload);
    },
    // region updated group pic
    setPicPath: (state, action) => {
      const chatId = action.payload.chatId;
      state.all_chats = state.all_chats.map((chat) => {
        if (chat?.chatId == chatId) {
          return {
            ...chat,
            picPath: action.payload?.picPath,
          };
        }
        return chat;
      });
    },
    // region updated group name
    setUpdatedGroupName: (state, action) => {
      const chatId = action.payload.chatId;
      state.all_chats = state.all_chats.map((chat) => {
        if (chat?.chatId == chatId) {
          return {
            ...chat,
            name: action.payload?.name,
          };
        }
        return chat;
      });
    },
    setMessagesInChat: (state, action) => {
      state.messages = action.payload;
    },
    setOtherContactList: (state, action) => {
      state.otherContactList = action.payload;
    },
    setRenderContactPanel: (state, action) => {
      state.renderContactPanel = action.payload;
    },
    setLastSeenRealTime: (state, action) => {
      state.lastSeenRealTime = action.payload;
    },
    setMessagesUpdatedName: (state, action) => {
      const senderName = action.payload;
      const updatedMessages = state.messages.map((message) => {
        return {
          ...message,
          senderName: senderName,
        };
      });
      state.messages = updatedMessages;
    },
    setMuteChatRealTime: (state, action) => {
      const { chatid, userid, IsMute, IsHide } = action.payload;

      // Handle hide/unhide: ensure we pass a plain serializable chat object to IndexedDB
      if (IsHide != null) {
        const id =
          typeof chatid === "string" && /^\d+$/.test(chatid)
            ? parseInt(chatid, 10)
            : chatid;

        if (IsHide === false) {
          // Unhide: take chat from hiddenChats (first match), build plain object and put into IndexedDB
          const unhideChat = state.hiddenChats?.find((c) => c?.chatId == id);
          if (unhideChat) {
            const plainChat = {
              chatId: unhideChat.chatId,
              name: unhideChat.name ?? null,
              lastMessage: unhideChat.lastMessage ?? null,
              otherUserId: unhideChat.otherUserId ?? null,
              picPath: unhideChat.picPath ?? null,
              createdDate: unhideChat.createdDate ?? null,
              userOnline: !!unhideChat.userOnline,
              userNickName: unhideChat.userNickName ?? null,
              unreadCount: unhideChat.unreadCount ?? 0,
              lastSeen: unhideChat.lastSeen ?? null,
              isHide: false,
              isMute: !!unhideChat.isMute,
              isFav: !!unhideChat.isFav,
              conversationType: unhideChat.conversationType ?? null,
              sortAccordingToLastSMS:
                unhideChat?.lastMessage?.createdDate ??
                unhideChat?.sortAccordingToLastSMS ??
                null,
              deleted: !!unhideChat.deleted,
              userData: unhideChat.userData ?? null,
              userDeleted: !!unhideChat.userDeleted,
              isExternal: !!unhideChat.isExternal,
              isAutoforward: !!unhideChat.isAutoforward,
              eventDate: unhideChat.eventDate ?? null,
              lastCall: unhideChat.lastCall ?? null,
            };
            // applyHideStatusToIndexedDB will insert/update mapped plainChat
            applyHideStatusToIndexedDB(id, false, plainChat);
            // move chat from hiddenChats -> all_chats
            state.all_chats.unshift(plainChat);
            state.hiddenChats = state.hiddenChats?.filter(
              (c) => c?.chatId != id
            );
          }
        } else {
          // Hide: remove from IndexedDB (per your request) and remove from all_chats
          applyHideStatusToIndexedDB(id, true, null);
          state.all_chats = state.all_chats?.filter(
            (chat) => chat?.chatId != id
          );
          // also add to hiddenChats if the chat existed in all_chats (keep minimal plain object)
          const removedChat = state.all_chats?.find((c) => c?.chatId == id);
          if (removedChat) {
            const hiddenPlain = {
              chatId: removedChat.chatId,
              name: removedChat.name ?? null,
              lastMessage: removedChat.lastMessage ?? null,
              isHide: true,
              isMute: !!removedChat.isMute,
              isFav: !!removedChat.isFav,
            };
            state.hiddenChats = [hiddenPlain, ...(state.hiddenChats || [])];
          }
        }
      }

      // Update mute/isHide flags in-memory
      state.all_chats = state.all_chats.map((chat) => {
        if (
          chat?.chatId == action.payload?.chatid &&
          action.payload?.IsMute != null
        ) {
          return { ...chat, isMute: action.payload.IsMute };
        } else if (
          chat?.chatId == action.payload?.chatid &&
          action.payload?.IsHide != null
        ) {
          return { ...chat, isHide: action.payload.IsHide };
        }
        return chat;
      });
    },
    setHiddenChats: (state, action) => {
      state.hiddenChats = action.payload;
    },
    setLastSeenRealTimeArr: (state, action) => {
      const existingIndex = state.lastSeenRealTimeArr.findIndex(
        (item) => item.userId === action.payload.userId
      );
      if (existingIndex !== -1) {
        state.lastSeenRealTimeArr[existingIndex] = action.payload;
      } else {
        state.lastSeenRealTimeArr.push(action.payload);
      }
    },
    setReaction: (state, action) => {
      state.messages = state.messages.map((message) =>
        message.messageId === action.payload.MessageId
          ? {
              ...message,
              reactions:
                message.reactions?.some(
                  (reaction) => reaction.reactorId === action.payload.UserId
                ) && action.payload.reactionRemoved
                  ? // If reaction exists, remove it
                    message.reactions.filter(
                      (reaction) => reaction.reactorId !== action.payload.UserId
                    )
                  : [
                      // ✅ Case 2: Remove old one (if any) then add new
                      ...(message.reactions || []).filter(
                        (reaction) =>
                          reaction.reactorId !== action.payload.UserId
                      ),
                      {
                        reaction: action.payload.reaction,
                        reactorId: action.payload.UserId,
                        messageId: action.payload.MessageId,
                        proifle_Pic: action.payload.proifle_Pic,
                        reactor_Name: action.payload.reactor_Name,
                        messageReactionId: action.payload.messageReactionId,
                      },
                    ],
            }
          : message
      );
    },

    receiveMessage: (state, action) => {
      const { chatId, message, tempId } = action.payload;
      const realTimeChat = {
        attachments: message?.attachments,
        createdDate: message?.createdDate,
        messageContent: message.messageContent,
        messageId: message.messageId,
        modifiedDate: message.modifiedDate,
        replyMessage: message.replyMessage,
        seenUsers: message.seenUsers,
        senderId: message.senderId,
        senderName: message.senderName ? message.senderName : message?.name,
        senderProfilePic: message.senderProfilePic,
        isHide: message?.isHide,
        status: message?.status,
      };
      if (chatId == state.chat_Id) {
        state.messages = state.messages.filter(
          (item) => item.messageId !== tempId
        );
        state.messages.push(realTimeChat);
        if (message.senderId != user_id) {
          setTimeout(() => {
            SendReadReceipt(
              user_id,
              parseInt(chatId),
              parseInt(message.messageId)
            );
          }, 1000);
        }
      }

      // region filter unique chat
      const singleChat = state.all_chats?.filter(
        (chat) => parseInt(chat?.chatId) === parseInt(chatId)
      );

      // Find the chat that matches the received message's chatId
      const chatIndex = (
        realTimeChat?.isHide === true ? state.hiddenChats : state.all_chats
      )?.findIndex((chat) => chat.chatId === chatId);

      const chatLists_InLeftSide =
        realTimeChat?.isHide === true ? state.hiddenChats : state.all_chats;

      if (chatIndex !== -1) {
        // Update the lastMessage and increment unreadCount
        const lastMessageContent =
          message?.messageContent && message.messageContent !== ""
            ? message.messageContent
            : message?.replyMessage
            ? "Quoted"
            : message?.attachments?.length
            ? "Attachment"
            : message?.messageContent;
        if (singleChat[0]?.lastMessage?.isDraft != true) {
          chatLists_InLeftSide[chatIndex].lastMessage = {
            ...message,
            messageContent: lastMessageContent,
          };
        }
        if (
          chatId !== state.chat_Id &&
          ((message?.isExternal && message?.isExternal === true) ||
            (message.senderId != user_id && message?.isDraft != true))
        ) {
          chatLists_InLeftSide[chatIndex].unreadCount += 1;
        }

        // Move the chat to the top of the list
        const [chat] = state.all_chats.splice(chatIndex, 1);

        if (chat.isFav) {
          state.all_chats.unshift(chat);
        } else {
          let insertIndex = state.all_chats.findIndex((c) => !c.isFav);
          if (insertIndex === -1) {
            insertIndex = state.all_chats.length;
          }
          state.all_chats.splice(insertIndex, 0, chat);
        }
      }
    },
    // region last message delete messages
    deleteMessage: (state, action) => {
      const { chatId, messageId } = action.payload;
      deleteMessage_From_IndexedDB_Parmanent(chatId, messageId);
      // Update the message in the active chat
      if (chatId === state.chat_Id) {
        const messageIndex = state.messages.findIndex(
          (m) => m.messageId == messageId
        );
        if (messageIndex !== -1) {
          state.messages.splice(messageIndex, 1);
        }
      }
      const chatIndex = state.all_chats.findIndex(
        (chat) => chat.chatId === chatId
      );
      // region last message
      if (chatIndex !== -1) {
        if (state.chat_Id === chatId) {
          if (state.messages?.length > 0) {
            const lastMessage = state.messages.reduce((latest, current) => {
              return new Date(current.createdDate) >
                new Date(latest.createdDate)
                ? current
                : latest;
            });
            state.all_chats[chatIndex].lastMessage = {
              messageId: lastMessage.messageId,
              messageContent: lastMessage.messageContent,
              createdDate: lastMessage.createdDate,
            };
          } else {
            state.all_chats[chatIndex].lastMessage = null;
          }
        } else {
          const event = new CustomEvent("refreshUserChats");
          window.dispatchEvent(event);
        }
      }
    },

    updateEditedMessage: (state, action) => {
      const { chatId, message } = action.payload;
      // Update the message in the active chat
      if (chatId === state.chat_Id) {
        const messageIndex = state.messages.findIndex(
          (m) => m.messageId === message.messageId
        );
        if (messageIndex !== -1) {
          state.messages[messageIndex] = message;
        }
      }

      // Find the chat that matches the edited message's chatId
      const chatIndex = state.all_chats.findIndex(
        (chat) => chat.chatId === chatId
      );

      if (chatIndex !== -1) {
        // Update the lastMessage if the edited message is the last one in the chat
        if (
          state.all_chats[chatIndex].lastMessage?.messageId ===
          message.messageId
        ) {
          state.all_chats[chatIndex].lastMessage.messageContent =
            message.messageContent;
        }
      }
    },
    // region add new chat
    newChatRecieve: (state, action) => {
      const isDuplicate = state.all_chats.some(
        (chat) => chat.chatId === action.payload.chatId
      );
      if (!isDuplicate && !state.isExternalFilter) {
        const chat = action.payload;
        if (chat.isFav) {
          state.all_chats.unshift(chat);
        } else {
          let insertIndex = state.all_chats.findIndex((c) => !c.isFav);
          if (insertIndex === -1) {
            insertIndex = state.all_chats?.length;
          }
          state.all_chats.splice(insertIndex, 0, chat);
        }
        // state.all_chats.unshift(action.payload);
      }
    },

    receiveReadReceipt: (state, action) => {
      const { readerUser, chatId, messageId, ConvoType } = action.payload;
      if (ConvoType === "Group") {
        // Only update if the chat matches the currently active chat
        if (chatId === state.chat_Id) {
          // Remove this user from all seenUsers arrays (clean-up for safety)
          state.messages.forEach((msg) => {
            msg.seenUsers = msg.seenUsers.filter(
              (user) => user.userId !== readerUser.userId
            );
          });

          // Find the target message
          const msgIndex = state.messages.findIndex(
            (m) => m.messageId == messageId
          );

          if (msgIndex !== -1) {
            // Add the user only if not already present (extra safety)
            const alreadySeen = state.messages[msgIndex].seenUsers.some(
              (user) => user.userId === readerUser.userId
            );

            if (!alreadySeen) {
              state.messages[msgIndex].seenUsers.push(readerUser);
            }
          }
        }
      } else if (ConvoType !== "Group") {
        if (chatId === state.chat_Id) {
          const messageIndex = state.messages.findIndex((m) =>
            m.seenUsers.some((item) => item.userId == readerUser.userId)
          );
          if (messageIndex !== -1) {
            const seenUserIndex = state.messages[
              messageIndex
            ].seenUsers.findIndex((item) => item.userId == readerUser.userId);
            if (seenUserIndex !== -1) {
              state.messages[messageIndex].seenUsers.splice(seenUserIndex, 1);
            }
          }

          const msgIndex = state.messages.findIndex(
            (m) => m.messageId == messageId
          );
          if (msgIndex !== -1) {
            state.messages[msgIndex].seenUsers.push(readerUser);
          }
        }
      }
    },

    receiveTyping: (state, action) => {
      const { user_id: typingUserId, userName, chatId } = action.payload;

      if (typingUserId === user_id) return;
      if (state.chat_Id == chatId) {
        state.typingUsers = userName;
        state.typingFlag = true;
        state.typingChatId = chatId;
      }
    },
    setChat_Id: (state, action) => {
      state.chat_Id = action.payload;
    },
    setAllChats: (state, action) => {
      state.all_chats = action.payload;
    },
    setAllChatsNickName: (state, action) => {
      const { chatId, name } = action.payload;
      state.all_chats = state.all_chats.map((chat) => {
        if (chat?.chatId == chatId) {
          return {
            ...chat,
            userNickName: {
              ...chat.userNickName,
              userNickName: name,
            },
          };
        }
        return chat;
      });
    },
    resetChatState: (state) => {
      return initialState;
    },
    setTypingFlag: (state, action) => {
      state.typingFlag = action.payload;
    },
    resetUnreadCount: (state, action) => {
      const { chatId, ishide } = action.payload;
      const chatLists_InLeftSide =
        ishide == true ? state.hiddenChats : state.all_chats;
      const chatIndex = chatLists_InLeftSide?.findIndex(
        (chat) => chat.chatId === chatId
      );

      if (chatIndex !== -1) {
        chatLists_InLeftSide[chatIndex].unreadCount = 0;
      }
      if (chatIndex !== -1) {
        state.all_chats[chatIndex].unreadCount = 0;
        (async function () {
          await indexedDB.chats.update(chatId, {
            unreadCount: 0,
          });
        })();
      }
    },
    setOtherUser: (state, action) => {
      const { otherUserId, userOnline } = action.payload;
      state.otherUserId = otherUserId;
      state.userOnline = userOnline;
    },
    setUserOnline: (state, action) => {
      const { userId, userOnline } = action.payload;
      const chatIndex = state.all_chats.findIndex(
        (chat) => chat.otherUserId === userId
      );
      if (chatIndex !== -1) {
        state.all_chats[chatIndex].userOnline = userOnline;
      }
      // update Contact Online, Offline
      state.allContacts = state.allContacts.map((contact) => {
        if (contact?.userid == userId) {
          return {
            ...contact,
            isOnline: userOnline,
          };
        }
        return contact;
      });

      if (state.otherUserId == userId) {
        state.userOnline = userOnline;
      }
    },

    setIsFav: (state, action) => {
      state.isFav = action.payload;
    },
    // for FavChat
    setIsFavChat: (state, action) => {
      state.isFavChat = action.payload;
    },
    setIsFavGroupChat: (state, action) => {
      state.isFavGroupChat = action.payload;
      const { chatId, isFav } = action.payload;
      state.all_chats = state.all_chats.map((chat) => {
        if (chat?.chatId == chatId) {
          return {
            ...chat,
            isFav: isFav,
          };
        }
        return chat;
      });
    },
    addRemoveFav: (state, action) => {
      const { chatId, fav } = action.payload;
      state.all_chats = state.all_chats.map((chat) => {
        if (chat?.chatId == chatId) {
          return {
            ...chat,
            isFav: fav,
          };
        }
        return chat;
      });
    },

    removeChat: (state, action) => {
      const chatId = action.payload;
      const chatIndex = state.all_chats.findIndex(
        (chat) => chat.chatId === chatId
      );

      if (chatIndex !== -1) {
        state.all_chats.splice(chatIndex, 1);
        if (state.chat_Id === chatId) {
          state.chat_Id = null;
        }
      }
    },
    setChatLoginId: (state, action) => {
      state.chatLoginId = action.payload;
    },
    setChatSelectedFromContactList: (state, action) => {
      state.chatSelectedFromContactList = action.payload;
    },
    setClipboardImageURL: (state, action) => {
      state.clipboardImageURL = action.payload;
    },
    setSelectedContactName: (state, action) => {
      state.selectedContactName = action.payload;
    },
    setSelectedContactProfileImage: (state, action) => {
      state.selectedContactProfileImage = action.payload;
    },
    setConvoType: (state, action) => {
      state.convoType = action.payload;
    },
    setSearchGroupName: (state, action) => {
      state.searchGroupName = action.payload;
    },
    setContactId: (state, action) => {
      state.contactId = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setClearChatRender: (state, action) => {
      state.clearChatRender = action.payload;
    },
    setMultiSelectChat: (state, action) => {
      state.multiSelectChat = action.payload;
    },
    setSelectedMessages: (state, action) => {
      state.selectedMessages = action.payload;
    },
    setSingleSelectedMessages: (state, action) => {
      const index = state.selectedMessages.findIndex(
        (msg) => msg.messageId === action.payload?.messageId
      );

      if (index === -1) {
        state.selectedMessages.push({
          messageId: action.payload?.messageId,
          senderId: action.payload?.senderId,
          replyMessageId: action.payload?.replyMessageId,
          attachment: action.payload?.attachment,
        });
      } else {
        state.selectedMessages.splice(index, 1);
      }
      const isCheck = state.senderId.some(
        (item) => action.payload?.messageId === item?.messageId
      );
      if (isCheck) {
        state.senderId = state.senderId.filter(
          (item) => action.payload?.messageId !== item?.messageId
        );
      } else {
        state.senderId.push({
          messageId: action.payload?.messageId,
          senderId: action.payload?.senderId,
          replyMessageId: action.payload?.replyMessageId,
          attachment: action.payload?.attachment,
        });
      }
    },

    setDraftFilesPrev: (state, action) => {
      state.draftFiles.push(action.payload);
    },
    setDraftFiles: (state, action) => {
      state.draftFiles = action.payload;
    },
    setDraftInput: (state, action) => {
      state.draftInput = action.payload;
    },
    setDraftAudioUrl: (state, action) => {
      state.draftAudioUrl = action.payload;
    },
    setDraftAudioBlob: (state, action) => {
      state.draftAudioBlob = action.payload;
    },
    setDraftMessage: (state, action) => {
      state.draftMessage = action.payload;
    },
    setDraftChatId: (state, action) => {
      state.draftChatId = action.payload;
    },
    setHitDraftApi: (state, action) => {
      state.hitDraftApi = action.payload;
    },
    setFileUploadProgress: (state, action) => {
      state.fileUploadProgress = action.payload;
    },
    setIsFileUploading: (state, action) => {
      state.isFileUploading = action.payload;
    },
    setCallLogsUserID: (state, action) => {
      state.callLogsUserID = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setChatGroupParticipants: (state, action) => {
      state.chatGroupParticipants = action.payload;
    },
    setChatGroupName: (state, action) => {
      state.chatGroupName = action.payload;
    },
    setCallLogsEventDetails: (state, action) => {
      state.callLogsEventDetails = action.payload;
    },
    setCallHistory: (state, action) => {
      // Drive the real-time call-logs refresh: CallSection watches state.chat.callHistory
      // and silently re-fetches page 0 whenever it changes. Without this assignment the
      // watcher never fired, so finished calls never appeared without a manual refresh.
      state.callHistory = action.payload;
      // region add callLogs in chatlist
      const user_id = localStorage.getItem("user_id");
      state.all_chats = state.all_chats.map((chat) => {
        if (chat?.chatId == action.payload?.[0]?.conversationId) {
          return {
            ...chat,
            lastCall: {
              duration: action.payload?.[0]?.duration,
              createdDate: action.payload?.[0]?.createdDate,
              callType: action.payload?.[0]?.callType,
              callStatus: action.payload?.[0]?.callStatus,
              callParticipants: action.payload?.[0]?.participants,
            },
          };
        }
        return chat;
      });
      // region add callLogs in chat messages
      if (parseInt(user_id) === action.payload?.[0]?.conversationId) {
        state?.callLogsEventDetails?.push(action?.payload?.[0]);
      }
    },
    setSync: (state, action) => {
      state.sync = action.payload;
    },
    setExternalContactNumber: (state, action) => {
      state.externalContactNumber = action.payload;
    },
    setIsExternalValidation: (state, action) => {
      state.isExternalValidation = action.payload;
    },
    setExternalChatLastMessage: (state, action) => {
      const chatId = action.payload?.chatId;
      state.all_chats = state.all_chats.map((chat) => {
        if (chat?.chatId == chatId) {
          return {
            ...chat,
            lastMessage: action.payload?.lastMessage,
          };
        }
        return chat;
      });
    },
    setChatParticipantCount: (state, action) => {
      state.chatParticipantCount = action.payload;
    },
    setIsUserContactExists: (state, action) => {
      state.isUserContactExists = action.payload;
    },
    setDeletedAttachmentFile: (state, action) => {
      const id = action.payload;
      if (!state.deletedAttachmentFile.includes(id)) {
        state.deletedAttachmentFile.push(id);
      }
    },
  },
});

export const {
  setDeletedAttachmentFile,
  setImageDeleted,
  setExternalNo,
  setOpenExternalModal,
  setIsExternalAllow,
  setSingleAutoForwardChat,
  setAutoForwardChat,
  setIsExternalFilter,
  setExternalName,
  setCallHistory,
  setSync,
  setCallLogsEventDetails,
  setMessagesInChat,
  setEventsInChat,
  addMessage,
  receiveMessage,
  updateEditedMessage,
  deleteMessage,
  newChatRecieve,
  receiveReadReceipt,
  receiveTyping,
  setChat_Id,
  setUser_Id,
  setAllChats,
  resetChatState,
  setTypingFlag,
  resetUnreadCount,
  setOtherUser,
  setUserOnline,
  setAction,
  setIsFav,
  setIsFavChat,
  setIsFavGroupChat,
  removeChat,
  setRenderFolder,
  setEmailId,
  setFoldersId,
  setFoldersName,
  setNewCreatedfolderName,
  setDispatchFoldersId,
  setFolderSideEmailData,
  setFavSideEmailData,
  setSideEmailData,
  setDraftEmails,
  setPendingDraftEmails,
  setChatLoginId,
  setDefaultEmailShow,
  setUser_Name,
  setRenderReaction,
  setReaction,
  setChatSelectedFromContactList,
  setContactList,
  addSingleContact,
  addReactions,
  setClipboardImageURL,
  setSelectedContactName,
  setSelectedContactProfileImage,
  setAllContacts,
  addSingleAllContacts,
  setEventsRealTime,
  setOtherContactList,
  setRenderContactPanel,
  setConvoType,
  setSearchGroupName,
  setContactId,
  setUserId,
  addSingleMainContactList,
  setMainContactList,
  addSingleParticipant,
  setPagination,
  setClearChatRender,
  setMultiSelectChat,
  setSelectedMessages,
  setSingleSelectedMessages,
  setDraftAudioUrl,
  setDraftInput,
  setDraftFiles,
  setDraftFilesPrev,
  setLastSeenRealTime,
  setLastSeenRealTimeArr,
  setDraftMessage,
  setDraftChatId,
  setDraftAudioBlob,
  setMuteChatRealTime,
  setHitDraftApi,
  setHiddenChats,
  setFileUploadProgress,
  setIsFileUploading,
  setPicPath,
  setMessagesUpdatedName,
  setAllChatsNickName,
  addRemoveFav,
  setCallLogsUserID,
  setUserData,
  setUpdatedGroupName,
  setChatGroupParticipants,
  setChatGroupName,
  setChatGroupLastSeen,
  setExternalContactNumber,
  setIsExternalValidation,
  setChatParticipantsCount,
  setAddRemoveParticipantsCount,
  setDeleteContact,
  setChatParticipantCount,
  setSingleNewChat,
  setExternalChatLastMessage,
  setIsUserContactExists,
  setNewExternalConversation,
  setExternalContactId,
} = chatSlice.actions;
export default chatSlice.reducer;
